<template>
  <div class="contentBox" :class="device=='mobile'?'mobileBox':''">
    <button class="btn btn-back" @click="goBack"></button>
    <web ref="web" class="webBox"></web>
    <div class="contv">
      <div class="icon icon1" @click="indexSub"></div>
      <div class="icon icon2" @click="examSub"></div>
    </div>
  </div>
</template>
<script>
import { indexData , switchUsers ,logoutStudent} from "@/assets/js/api";
import web from './../components/comment/web.vue';
export default {
  name: "login",
  data() {
    return {
      token:'',
      device:''
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '家长';
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.getDetail();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    }
  },
  methods: {
    async getDetail(){
      var that = this;
      try {
        const response = await indexData(this.token);
        if(response.code == 200){
          that.accountObj = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    examSub(){
      this.$router.push('/examSite');
    },

    indexSub(){
      this.$router.push('/identityIndex');
    },

    goBack() {
      var that = this;
      that.$router.go(-1);
      setTimeout(function(){
        window.location.reload();
      },100)
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    background-image: url(~@/assets/images/index-bg.png);
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    padding: 101px 0 75px;
  }

  .contv{
    background-color: transparent;
    width: 100%;
    text-align: center;
  }

  .icon{
    width: 500px;
    height: 500px;
    background-size: 500px 500px;
    display: inline-block;
    vertical-align: top;
  }

  .icon1{
    background-image: url(~@/assets/images/icon19.png);
    margin-right: 200px;
  }

  .icon2{
    background-image: url(~@/assets/images/icon20.png);
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
  }
</style>



// WEBPACK FOOTER //
// src/identity/parent.vue